import { Box } from '@mui/material';
import { useIsDesktop } from '@src/main/ui/components/common/ThemeProvider/useIsDesktop';
import MainLayout from '@src/main/ui/components/layout/common/MainLayout';
import NavbarDesktop from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/NavbarDesktop';
import NavbarMobile from '@src/main/ui/components/layout/common/Navbar/NavbarMobile/NavbarMobile';
import { FC, PropsWithChildren } from 'react';

const LayoutWithNavbarEmbed: FC = () => <MainLayout OutletParent={NavbarAndOutlet} />;

const NavbarAndOutlet: FC<PropsWithChildren> = ({ children }) => {
  const isDesktop = useIsDesktop();
  return (
    <>
      {isDesktop ? (
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
          <NavbarDesktop />
          <Box component="main" sx={{ flexGrow: 1, p: 3, paddingTop: 1 }}>
            {children}
          </Box>
        </Box>
      ) : (
        <>
          <Box component="main" sx={{ flexGrow: 1, p: 1, paddingBottom: 8, height: '100%' }}>
            {children}
          </Box>
          <NavbarMobile />
        </>
      )}
    </>
  );
};

export default LayoutWithNavbarEmbed;
